import { render, staticRenderFns } from "./RepsColumn.vue?vue&type=template&id=3a5fd822&"
import script from "./RepsColumn.vue?vue&type=script&lang=js&"
export * from "./RepsColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports